import API from '../../../../common/http/api.fetch';
import { TAB_SWITCH } from '../../../../common/tabs/tabs.constants';
import { formatDate } from '../../../../common/utils/util.date';
import * as TYPE from '../pnp-docs.actions.types';
import { IDS } from './pnp-approval.constants';

export const getDocument = (filter) => {
    return (dispatch) => {
        return API.fetch({
            url: `/pnp/approval/docs`,
            method: 'GET',
            params: {
                location: filter.location,
                offset: filter.offset,
                limit: filter.limit,
                keyword: filter.keyword,
                documentCategory: filter.documentCategory,
                documentType: filter.documentType,
                createdDateFrom: filter.createdDateFrom ? formatDate(filter.createdDateFrom) : null,
                createdDateTo: filter.createdDateTo ? formatDate(filter.createdDateTo) : null,
                linkWithAccreditation: filter.linkWithAccreditation,
                exportFormat: filter.exportFormat,
                exportColumns: filter.exportColumns
            }
        }).then(({ data }) => {
            if (filter.exportFormat) {
                return data;
            }
            dispatch({
                type: 'GRID_FETCH',
                id: 'pnpDocumentApprovalGrid',
                items: data.items.map((item) => {
                    return {
                        id: item.uta_id,
                        vdoId: item.vdo_id,
                        title: item.title,
                        version: item.version,
                        docNum: item.doc_num,
                        documentApplicationType: item.document_application_type,
                        documentType: item.document_type,
                        documentCategory: item.document_category,
                        approvalDueDate: item.task_due_date,
                        documentDueDate: item.doc_due_date,
                        path: item.path,
                        docStatus: item.doc_status,
                        reviewType: item.review_type,
                        createdDate: item.doc_date,
                        author: item.author,
                        linkWithAccreditation: item.is_link_with_accreditation,
                        headOffice: item.head_office_name,
                        siteLocation: item.site_location_name,
                        department: item.department_name,
                        downloadAllowed: item.download_allowed
                    }
                }),
                itemsCount: parseInt(data.items_count)
            })
        });
    }
}


export const getDocumentDetails = (id) => {
    return (dispatch) => {
        return API.fetch({
            url: `/pnp/doc/task/details`,
            method: 'GET',
            params: { id }
        }).then(({ data }) => {
            dispatch({
                type: TYPE.PNP_DOCUMENT_DETAILS,
                id: 'pnpDocument',
                data: data[0],
            })
        });
    }
};


export const saveDocument = (data) => {
    return (dispatch) => {
        return API.fetch({
            url: `/pnp/doc/comment/save`,
            method: 'POST',
            data: {
                id: data.id,
                comment: data.comment
            }
        }).then((response) => {
            dispatch({
                type: 'GRID_RELOAD',
                id: 'pnpDocumentApprovalGrid'
            })
            if (!data.id) {
                dispatch({
                    type: 'PNP_DOCUMENT_RESET',
                    id: 'pnpDocument'
                });
            }
            dispatch({
                type: TAB_SWITCH,
                id: IDS.app_policies_documents_approval,
                selectedState: IDS.app_policies_documents_approval_listing,
                selectedTabIndex: 0
            });
        });
    }
}

export const reviewApproveDocument = (data) => {
    return (dispatch) => {
        return API.fetch({
            url: `/pnp/doc/status/save`,
            method: 'POST',
            data: {
                id: data.id,
                review_id: data.reviewId
            }
        }).then((response) => {
            dispatch({
                type: 'GRID_RELOAD',
                id: 'pnpDocumentApprovalGrid'
            })
            if (!data.id) {
                dispatch({
                    type: 'PNP_DOCUMENT_RESET',
                    id: 'pnpDocument'
                });
            }
            dispatch({
                type: TAB_SWITCH,
                id: IDS.app_policies_documents_approval,
                selectedState: IDS.app_policies_documents_approval_listing,
                selectedTabIndex: 0
            });
        });
    }
}

export const getDocumentReviewerApproverDetails = (id) => {
    return (dispatch) => {
        return API.fetch({
            url: `/pnp/doc-reviewer-approver/details`,
            method: 'GET',
            params: { id }
        }).then(({ data }) => {
            const reviewers = data.filter((type) => type.type_name === 'Document Review Task')
            const approvers = data.filter((type) => type.type_name === 'Document Approval Task')
            dispatch({
                type: TYPE.PNP_DOCUMENT_REVIEWER_APPROVER_DETAILS,
                id: 'pnpDocument',
                data: { reviewers, approvers },
            })
        });
    }
};

